export const calculateFieldNameWithGroup = field => (field.options?.group_name ? `${field.options.group_name} / ${field.name}` : field.name);

export const selectFieldsAvailableForInterpolationOptions = fields => fields
  .filter(field => !['User', 'Attachment', 'CoverImage'].includes(field.type))
  .map(field => ({
    value: calculateFieldNameWithGroup(field),
    id: `field_id:${field.id}`,
    type: field.type,
  }));
